export default __webpack_public_path__ + "static/0116-9d1434f183f7153f6631ec34fc03c864.png";